export const STATUS = {
  CREATED: "created",
  REQUESTED_BY_USER: "requested",
  APPROVED_BY_DEPT_HEAD: "by_department",
  REJECTED: "rejected",
  APPROVED_BY_DIRECTOR: "approved",
};
